// Migrated
// Translated
<template>
  <div
    v-if="activeItinerary && filteredActiveItinerary?.length"
    class="product-featured-itinerary"
  >
    <div class="mt-4 md:mt-4">
      <LazyInfoSection
        v-if="itineraries && itineraries.length > 1"
        class="print-hidden print-no-overlap"
        variant="background"
        :title="$t('multipleItineraryTitle')"
        title-key="multipleItineraryTitle"
        :text="$t('multipleItineraryDescription')"
        text-key="multipleItineraryDescription"
      >
        <template #icon>
          <i-calendar-blank fill="currentColor" />
        </template>
        <div class="mt-2 -ml-2">
          <span
            v-for="(itinerary, index) in itineraries"
            :key="index"
            class="mr-4"
          >
            <input
              :id="'i' + index"
              class="special-checkbox"
              type="radio"
              name="activeItineraryIndex"
              :checked="index === activeItineraryIndex"
              :value="index"
              @input="$emit('selectItinerary', $event.target.value)"
            />
            <label
              class="mb-0"
              :for="'i' + index"
              :data-translation="itinerary?.name_translationkey"
            >{{ itinerary.name }}</label>
          </span>
        </div>
      </LazyInfoSection>
    </div>
    <div class="rows">
      <div
        v-for="itineraryDay in filteredActiveItinerary"
        v-show="expandAll"
        :key="itineraryDay.id"
        class="w-12/12 mt-4 md:mt-4 mt-print-0 p-0 print-no-overlap"
      >
        <LazyItineraryDay
          v-if="itineraryDay.day !== 'x'"
          :is-destination="isDestination"
          :active-marker="activeMarker"
          :itinerary-day="itineraryDay"
          @set-marker="$emit('setMarker', itineraryDay.day)"
          @open-map="$emit('openMap', itineraryDay.day)"
          @show-preview="showPreview"
        />
        <LazyItineraryBox
          v-if="itineraryDay.day === 'x'"
          :box-type="itineraryDay.box_type"
          :itinerary-day="itineraryDay"
          :is-destination="isDestination"
        >
          <div
            :data-translation="itineraryDay?.htmltext_translationkey"
            v-html="itineraryDay.htmltext"
          />
        </LazyItineraryBox>
      </div>
    </div>
    <LazyMediaModal
      v-if="mediaModal"
      :visible="mediaModal"
      :title="modalTitle"
      :media-list="mediaList"
      :default-current-index="currentIndex"
      size="xl"
      centered
      show-close
      @on-hide="hidePreview"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    activeItinerary: {
      type: Object,
      default: () => ({ itinerary: [] }),
    },

    itineraries: {
      type: Array,
      required: true,
    },

    activeItineraryIndex: {
      type: Number,
      required: true,
    },

    activeMarker: {
      type: String,
      default: null,
    },

    isDestination: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['setMarker', 'openMap', 'selectItinerary'],

  data () {
    return {
      expandedDay: null,
      expandAll: true,
      mediaModal: false,
      currentIndex: 0,
      mediaList: [],
      modalTitle: '',
    }
  },

  computed: {
    filteredActiveItinerary () {
      return this.activeItinerary?.itinerary?.filter(itinerary => !!(
        itinerary.title ||
        itinerary.htmltext ||
        itinerary.map_points?.length ||
        itinerary.media?.length
      ))
    },
  },

  watch: {
    activeItinerary (v) {
      if (v.itinerary?.length === 1) {
        this.expandAll = true
      }
    },
  },

  mounted () {
    if (this.activeItinerary.itinerary?.length === 1) {
      this.expandAll = true
    }

    window.matchMedia('print').addListener((e) => {
      if (e.matches) {
        this.expandAll = true
      }
    })
  },

  methods: {
    expandDay (day) {
      this.$emit('setMarker', day)

      this.expandedDay = day
    },

    toggleExpandAll () {
      this.expandAll = !this.expandAll
    },

    hidePreview () {
      this.mediaModal = false
    },

    showPreview ({ currentIndex, mediaList, title }) {
      this.modalTitle = title
      this.mediaModal = true
      this.currentIndex = currentIndex

      this.mediaList = mediaList.map(media => ({
        ...media,
        type: media.type === 'cloudinary_image' ? 'cloudinary' : media.type,
        mediatype: media.type === 'cloudinary_image' ? 'image' : media.type,
      }))
    },
  },
})
</script>

<style lang="scss">
.product-featured-itinerary {
  .itinerary-column {
    @media (max-width: theme('screens.lg')) {
      margin: 0.3em 0;
    }

    &:hover {
      background: theme('colors.lightest-blue-transparent');
    }
  }

  .itinerary-expand-all .itinerary-description {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
</style>
